<script>
	import {push,replace} from "svelte-spa-router";
	import Controlador from "../controlador.svelte";
	import {docs,logueo} from "../store.js";
	import {onMount} from "svelte";
	export let params;
	let c,em;
    let nombre = "",apellido ="",sobrenombre = "",celular ="",instagram="",cargo="";
	function agregar(){
		if (params.id == "nuevo"){
		c.agregarEmpleado({
			nombre: nombre.trim(),
			apellido: apellido.trim(),
			sobrenombre: sobrenombre.trim(),
			celular: celular.trim(),
            instagram: instagram.trim(),
            cargo: cargo.trim()
		});
		} else {
			c.editarEmpleado(em,{
				nombre:nombre.trim(),
				apellido: apellido.trim(),
				sobrenombre: sobrenombre.trim(),
				celular: celular.trim(),
				instagram: instagram.trim(),
                cargo: cargo.trim()
            })
		}
		push("/empleados");
	}
	onMount(()=>{
		if (params.id != "nuevo"){
			em = $docs.filter((el)=> el._id == params.id)[0];
			nombre = em.nombre.trim();
			apellido = em.apellido.trim();
			sobrenombre = em.sobrenombre.trim();
			celular = em.celular.trim();
			instagram = em.instagram.trim();
            cargo = em.cargo.trim();
		}
		if (!$logueo){
			replace('/');
		}
	})
</script>
<Controlador bind:this={c} />
<div class="w-full p-4 h-full flex flex-col items-center justify-start">
	<a href="#/empleados" class="w-full m-2 p-2 bg-red-500 text-white cursor-pointer flex items-center justify-center rounded shadow">
			<i class="ri-arrow-left-line" />
			Volver
	</a>
	<input bind:value={nombre} type="text" placeholder="Nombre" class="w-full m-2 p-2 rounded shadow" />	
	<input bind:value={apellido} type="text" placeholder="Apellido" class="w-full m-2 p-2 rounded shadow" />	
	<input bind:value={sobrenombre} type="text" placeholder="Sobrenombre" class="w-full m-2 p-2 rounded shadow" />	
    <select bind:value={cargo} class="w-full m-2 p-2 rounded shadow">
            <option selected={cargo==""} value="">Elegir Cargo</option>
        <option selected={cargo == "Encargado"} value="Encargado" >Encargado/a</option>
        <option selected={cargo == "Tatuador"} value="Tatuador" >Tatuador/a</option>
        <option selected={cargo == "Perforador"} value="Perforador">Perforador/a</option>
     
    </select>
    <input bind:value={celular} type="tel" placeholder="Celular (con +54 y caracteristica)" class="w-full m-2 p-2 rounded shadow" />	
	<input bind:value={instagram} type="text" placeholder="Instagram" class="w-full m-2 p-2 rounded shadow" />	
	{#if cargo != "" && nombre != "" && apellido !="" && sobrenombre!="" && celular !=""}	
		<button on:click={agregar} class="w-full m-2 p-2 bg-red-500 text-white cursor-pointer flex items-center justify-center rounded shadow">
			<i class="ri-add-line" />
			{(params.id != "nuevo"?"Editar":"Agregar")}
		</button>
	{/if}
</div>
